import { selectAll } from 'd3-selection';

const currency = '£';


function createLookup(data) {
  const lookup = {};

  Object.entries(data)
    .forEach(function([key, d]) {
      for (const [name, p] of Object.entries(d)) {
        const id = `${key}-${name}`;
        const price = `${currency}${p}`;
        lookup[id] = price;
      }
    });

  return lookup;
}


function addPricing(data) {
  const lookup = createLookup(data);
  const query = '[data-price]';

  selectAll(query)
    .each(function() {
      const price = lookup[this.dataset.price];
      if (price) { this.textContent = price; }
    });
}


export { addPricing };
